// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__nmh0r","copyright":"Footer_copyright__m+9hI"};